var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor_form"},[_c('h3',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.label))]),_c('quill-editor',{staticClass:"vx-col w-full mb-5",attrs:{"value":_vm.value,"name":_vm.name},on:{"change":function($event){return _vm.$emit('input', $event.html)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }